export default "__VITE_ASSET__54cgXdBk__"